import { Editor } from 'slate'
import { CustomEditor } from 'modules/community/types/custom-editor'

export const withMentions = (editor: Editor): CustomEditor => {
  const { isInline, isVoid } = editor

  editor.isInline = element => {
    return element.type === 'mention' ? true : isInline(element)
  }

  editor.isVoid = element => {
    return element.type === 'mention' ? true : isVoid(element)
  }

  return editor
}
